(ns practitest.frontend.components2.test-type
  (:require [reagent.core :as reagent]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]))

(def automated-test-types #{"xBotTest" "ApiTest" "FirecrackerTest" "EggplantTest"})
(def automated-test-fields #{:is_automated_enabled :client_id :script_path :results_path
                             :num_of_results :is_automated_clicked :automation_type
                             :suite_path :script_name :automated_test_design :script_repository})

(def types-map
  {"ScriptedTest"    {:title (get-translation "test-type.scripted" "Scripted")
                      :icon  icons/scripted-test}
   "ExploratoryTest" {:title (get-translation "test-type.exploratory" "Exploratory")
                      :icon  icons/exploratory-test}
   "xBotTest"        {:title (get-translation "test-type.xbot" "xBot")
                      :label (get-translation "test-type.xbot-agent" "xBot Agent")
                      :icon  icons/xbot-test}
   "EggplantTest"    {:title (get-translation "test-type.eggplant" "Eggplant")
                      :icon  icons/eggplant-test}
   "FirecrackerTest" {:title (get-translation "test-type.firecracker" "Firecracker")
                      :label (get-translation "test-type.firecracker-sourced" "Firecracker sourced test")
                      :icon  icons/firecracker-test}
   "ApiTest"         {:title (get-translation "test-type.api" "API")
                      :label (get-translation "test-type.api-sourced" "API sourced test")
                      :icon  icons/api-test}
   "BDDTest"         {:title (get-translation "test-type.bdd" "BDD")
                      :icon  icons/bdd-test}
   "AutomatedTest"   {:title (get-translation "test-type.automated" "Automated")
                      :icon  icons/mux-play}})

(defn get-type-label
  [type]
  (:title (get types-map type)))

(defn get-type-icon
  [type]
  (when-let [icon (:icon (get types-map type))]
    [icon]))

(defn type-with-label
  [type]
  [:span.test-type-span
   (get-type-icon type)
   (get-type-label type)])

(defn is-xbot-test?
  [instance]
  (= "xBotTest" (:test/test_type instance)))
